import { Box, Button, CircularProgress } from '@mui/material'
import { Dispatch, SetStateAction, useState } from 'react'

import { themeColors } from '../../theme'
import { Modal } from '../Modal/Modal'

interface RerunGeneticsModalProps {
  setShowRerunGeneticsModal: Dispatch<SetStateAction<boolean>>
  showRerunGeneticsModal: boolean
  rerunGenetics: (patientId: number) => Promise<any>
  patientId: number
}

export const RerunGeneticsModal = ({
  showRerunGeneticsModal,
  setShowRerunGeneticsModal,
  rerunGenetics,
  patientId,
}: RerunGeneticsModalProps) => {
  const [loading, setLoading] = useState(false)

  return (
    <Modal
      open={showRerunGeneticsModal}
      setOpen={setShowRerunGeneticsModal}
      title={'Rerun Genetics?'}
      width={'28%'}
      ModalContent={
        <Box
          sx={{
            width: '92%',
            margin: 'auto',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={() => {
              setShowRerunGeneticsModal(false)
            }}
            variant='contained'
            style={{
              fontSize: '16px',
              marginTop: '10px',
              width: '80px',
              backgroundColor: themeColors.red,
              borderColor: 'transparent',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              setLoading(true)
              await rerunGenetics(patientId)
              setLoading(false)
              setShowRerunGeneticsModal(false)
            }}
            variant='contained'
            style={{
              fontSize: '16px',
              marginTop: '10px',
              width: '80px',
              borderColor: 'transparent',
            }}
          >
            {loading ? <CircularProgress size={20} /> : 'Yes'}
          </Button>
        </Box>
      }
    />
  )
}
